<script>
export default {
  props: {
    id: {
      type: String,
      required: true
    },
    title: {
      type: String,
      required: false
    },
    size: {
      type: String,
      required: false
    }
  },
  methods: {
    open() {
      let modal = bootstrap.Modal.getOrCreateInstance(this.$el);
      modal.show();
    },

    close() {
      let modal = bootstrap.Modal.getOrCreateInstance(this.$el);
      modal.hide();
    }
  },
}
</script>

<template>
  <div class="modal fade" :id="id" tabindex="-1" :aria-labelledby="id + 'Label'" aria-hidden="true">
    <div :class="{'modal-dialog modal-dialog-centered': true, [`modal-${this.size}`]: size}">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white">
          <h2 v-if="title" class="modal-title fs-5" :id="id + 'Label'">{{ title }}</h2>
          <button type="button" class="btn-close text-white" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>

        <div class="modal-body">
          <slot></slot>
        </div>

        <div class="modal-footer" v-if="$slots.footer">
          <slot name="footer"></slot>
        </div>
      </div>
    </div>
  </div>
</template>